var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-collapse-transition", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c("el-col", { attrs: { span: 8 } }, [
              _c(
                "div",
                { staticClass: "form-checkbox-group" },
                [
                  _c(
                    "el-form-item",
                    {
                      key: "siTire_" + (_vm.isBailianFlag ? "by" : ""),
                      staticClass: "form-item-title project-form-item",
                      attrs: {
                        label: _vm.$t(
                          "retailStoresInfo.form.mainServicesInStore.serviceItem"
                        ),
                        prop: "siTire",
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("retailStoresInfo.form.storeFacEqu.tire")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: _vm.type !== "edit",
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "retailStoresInfo.form.storeFacEqu.siBalance"
                          ),
                        },
                        model: {
                          value: _vm.form.siBalance,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siBalance", $$v)
                          },
                          expression: "form.siBalance",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: _vm.type !== "edit",
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "retailStoresInfo.form.storeFacEqu.siWheelPosition"
                          ),
                        },
                        model: {
                          value: _vm.form.siWheelPosition,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siWheelPosition", $$v)
                          },
                          expression: "form.siWheelPosition",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: _vm.type !== "edit",
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "retailStoresInfo.form.storeFacEqu.siTireRepair"
                          ),
                        },
                        model: {
                          value: _vm.form.siTireRepair,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siTireRepair", $$v)
                          },
                          expression: "form.siTireRepair",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: _vm.type !== "edit",
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "retailStoresInfo.form.storeFacEqu.siValve"
                          ),
                        },
                        model: {
                          value: _vm.form.siValve,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siValve", $$v)
                          },
                          expression: "form.siValve",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("retailStoresInfo.form.storeFacEqu.nonTire")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: _vm.type !== "edit",
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "retailStoresInfo.form.storeFacEqu.siEngineOil"
                          ),
                        },
                        model: {
                          value: _vm.form.siEngineOil,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siEngineOil", $$v)
                          },
                          expression: "form.siEngineOil",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: _vm.type !== "edit",
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "retailStoresInfo.form.storeFacEqu.siBrake"
                          ),
                        },
                        model: {
                          value: _vm.form.siBrake,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siBrake", $$v)
                          },
                          expression: "form.siBrake",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: _vm.type !== "edit",
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "retailStoresInfo.form.storeFacEqu.siFacialClean"
                          ),
                        },
                        model: {
                          value: _vm.form.siFacialClean,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siFacialClean", $$v)
                          },
                          expression: "form.siFacialClean",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: _vm.type !== "edit",
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "retailStoresInfo.form.storeFacEqu.siPerishableGoods"
                          ),
                        },
                        model: {
                          value: _vm.form.siPerishableGoods,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siPerishableGoods", $$v)
                          },
                          expression: "form.siPerishableGoods",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "retailStoresInfo.form.mainServicesInStore.otherItem"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          maxlength: "10",
                          placeholder:
                            _vm.type !== "edit"
                              ? ""
                              : _vm.$t("retailStoresInfo.input.inputHolder"),
                          clearable: "",
                          disabled: _vm.type !== "edit",
                        },
                        model: {
                          value: _vm.form.siOther,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siOther", $$v)
                          },
                          expression: "form.siOther",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "siMain_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.mainServicesInStore.mainItem"
                      ),
                      prop: "siMain",
                      rules: _vm.rules.chooseEmpty,
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          disabled: _vm.type !== "edit",
                          placeholder: _vm.$t(
                            "retailStoresInfo.input.selectHolder"
                          ),
                        },
                        model: {
                          value: _vm.form.siMain,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siMain", $$v)
                          },
                          expression: "form.siMain",
                        },
                      },
                      _vm._l(
                        _vm.lookupList["MAIN_SERVICE_ITEMS"],
                        function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.code,
                              disabled: _vm.type !== "edit",
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "siMainPercentage_" + (_vm.isBailianFlag ? "by" : ""),
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.mainServicesInStore.busVolume"
                      ),
                      prop: "siMainPercentage",
                      rules: _vm.rules.iptEmpty,
                    },
                  },
                  [
                    _c(
                      "FormInputNumber",
                      {
                        attrs: {
                          val: _vm.form.siMainPercentage,
                          max: 100,
                          step: 0.01,
                          mode: _vm.type,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "siMainPercentage",
                              $event
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "append" }, slot: "append" },
                          [_vm._v("%")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }